import { render } from "./BuyerOrderDetails.vue?vue&type=template&id=60db310a&scoped=true"
import script from "./BuyerOrderDetails.vue?vue&type=script&lang=js"
export * from "./BuyerOrderDetails.vue?vue&type=script&lang=js"

import "./BuyerOrderDetails.vue?vue&type=style&index=0&id=60db310a&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60db310a"]])

export default __exports__